import Link from 'next/link';
import React from 'react';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { LuArrowRight } from 'react-icons/lu';
import { MdKeyboardArrowRight } from 'react-icons/md';

export type ProfileSidebarItemProps = {
  name: string;
  icon: React.ReactNode;
  variant?: any;
  href: string | (() => string);
  hardLink?: boolean;
  pathname: string;
};

export const ProfileSidebarItem = ({
  name,
  icon,
  variant,
  hardLink,
  href,
}: ProfileSidebarItemProps) => {
  const LinkComponent = hardLink ? 'a' : Link;
  const hrefString = typeof href === 'function' ? href() : href;

  return (
    <LinkComponent
      key={hrefString + name}
      href={hrefString ?? '#'}
      className={cn(
        'group',
        'flex h-[58px] items-center justify-between gap-3 rounded-[20px] border px-3 transition-all hover:border-primary hover:bg-primary',
      )}
    >
      {icon && <span className="transition-all group-hover:[&_svg]:text-white">{icon}</span>}
      <Heading
        tag="h6"
        title={name}
        className={{
          container: 'w-full flex-1',
          title: cn(
            'text-left text-foreground transition-all group-hover:text-white',
            variant == 'destructive' ? 'text-[#666666]' : 'text-black',
          ),
        }}
      />
      {variant !== 'destructive' && (
        <MdKeyboardArrowRight
          size={20}
          className="text-[#D1D5D8] transition-all group-hover:text-white"
        />
      )}
    </LinkComponent>
  );
};
